import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, FlexBox } from '@kis-technologies/kis-ui';
import { routes } from '../../routes/routesArray';

// used for setting state
import { useActions } from 'hooks/useActions';
import { useSelector } from 'react-redux';
import { actions as authActions, selectors as authSelectors } from 'services/auth';
import { actions as ticketingActions, selectors as ticketingSelectors } from 'services/ticketing';

// test data
import automationData from './testData';

const UIAutomationView: React.FC = () => {
  const { adminLogin } = useActions({ adminLogin: authActions.adminLogin });
  const navigate = useNavigate();
  const adminId = useSelector(authSelectors.selectAdminId);
  const { createSession } = useActions({ createSession: ticketingActions.createSession });
  const sessionId = useSelector(ticketingSelectors.selectSession);
  const { setGenresConfig, setEventsConfig, setTiersConfig } = useActions(ticketingActions);

  useEffect(() => {
    adminLogin({ email: automationData.email, password: automationData.password });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (adminId) {
      if (sessionId) {
        setGenresConfig({
          page: automationData.genreConfig.page,
          selected: automationData.genreConfig.selected
        });

        setEventsConfig({
          page: automationData.eventsConfig.page,
          selected: automationData.eventsConfig.selected
        });

        setTiersConfig({
          selected: automationData.tiersConfig.selected
        });
      } else {
        createSession();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminId, sessionId, setGenresConfig, setEventsConfig, setTiersConfig]);

  return (
    <FlexBox>
      {routes.map((r, idx) => (
        <Button key={idx} appearance="primary" onClick={() => navigate(r.path)} data-testid={r.testID}>
          {r.name}
        </Button>
      ))}
    </FlexBox>
  );
};

export default UIAutomationView;
